<template>
  <div style="background-color:#F9F9F9">
    <div class="box-top">
      <van-image
          width="100%"
          height="175px"
          position="left"
          radius="0px 0px 10px 10px"
          src="/images/header.png"
      />
    </div>

    <div style="margin: 12px;position: relative;top: -60px">
      <div class="box-inspection" @click="addCar">
        <div>
          <van-icon name="/images/add.png" size="40"/>
        </div>
        <div style="margin-top: 5px;">添加车辆办理年检</div>
      </div>

      <div class="box-handle">
        <div style="padding: 13px 12px 13px 12px;display: flex;flex-flow: row;align-items: center;">
          <div style="color: #333333;font-size: 20px;font-weight: bold;">办理方式</div>
          <div @click="goIntro" style="display: flex;flex-flow: row;align-items: center;">
            <van-icon name="/images/question.png" size="20" style="margin-left: 10px;margin-right: 3px;"/>
            <div style="font-size: 15px; color: #3E82FF;font-weight: 600">年检介绍</div>
          </div>
        </div>
        <van-divider :style="{borderColor: 'rgb(220 222 224)', marginTop: '0px'}"></van-divider>

        <!--        <van-radio-group v-model="radio">-->
        <!--          <div :class="radio === '1' ? 'box-handle-select': ''"-->
        <!--               style="display: flex;flex-flow: wrap;justify-content: space-between;font-size: 17px;padding: 16px 10px;margin-top: -16px;">-->
        <!--            <div>预约检车<span style="color: #999999;font-size: 14px;margin-left: 9px;font-weight: 500;">一键预约 方便快捷</span>-->
        <!--            </div>-->
        <!--            <van-radio name="1"></van-radio>-->
        <!--          </div>-->
        <!--          <div :class="radio === '2' ? 'box-handle-select': ''"-->
        <!--               style="display: flex;flex-flow: wrap;justify-content: space-between;font-size: 17px;padding: 16px 10px;">-->
        <!--            <div>代驾检车<span style="color: #999999;font-size: 14px;margin-left: 9px;">上门取车 省心省力</span></div>-->
        <!--            <van-radio name="2"></van-radio>-->
        <!--          </div>-->
        <!--        </van-radio-group>-->


        <van-radio-group v-model="radio">
          <div @click="selectRadio" :class="radio === '1' ? 'box-handle-select': ''"
               style="display: flex;flex-flow: wrap;justify-content: space-between;font-size: 17px;padding: 16px 10px;margin-top: -16px;">
            <div>预约检车<span style="color: #999999;font-size: 14px;margin-left: 9px;font-weight: 500;">低至100元</span>
<!--            <div>预约检车<span style="color: #999999;font-size: 14px;margin-left: 9px;font-weight: 500;">低至210元</span>-->
            </div>
            <van-radio name="1"></van-radio>
          </div>
          <div @click="selectRadio2" :class="radio === '2' ? 'box-handle-select': ''"
               style="display: flex;flex-flow: wrap;justify-content: space-between;font-size: 17px;padding: 16px 10px;">
            <div>代驾检车<span style="color: #999999;font-size: 14px;margin-left: 9px;">低至260元</span></div>
<!--            <div>代驾检车<span style="color: #999999;font-size: 14px;margin-left: 9px;">低至240元</span></div>-->
            <van-radio name="2"></van-radio>
          </div>
        </van-radio-group>
      </div>

      <div class="box-process">
        <div style="padding: 13px 12px 13px 12px;display: flex;">
          <div style="color: #333333;font-size: 20px;font-weight: bold;">办理流程及业务介绍</div>
        </div>
        <van-divider :style="{borderColor: 'rgb(220 222 224)', marginTop: '0px'}"></van-divider>

        <div v-if="radio === '1'" style="font-size: 14px;display: flex;color: #666666;justify-content: center;">
          <div class="appoint-process">
            <div>
              <van-icon name="bill-o" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;">预约付款</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="orders-o" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;">准备资料</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="/images/car.png" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;">自驾到站</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="passed" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;">检测完成</div>
          </div>
        </div>

        <div v-else style="font-size: 14px;display: flex;color: #666666;justify-content: center;">
          <div class="appoint-process">
            <div>
              <van-icon name="bill-o" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;white-space:nowrap;">预约付款</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="orders-o" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;white-space:nowrap;">准备资料</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="/images/car.png" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;white-space:nowrap;">上门取车</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="passed" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;white-space:nowrap;">检测完成</div>
          </div>
          <div style="margin-top: 2px;">
            <van-icon name="/images/right.png" size="20" color="#666666"/>
          </div>
          <div class="appoint-process">
            <div>
              <van-icon name="/images/car.png" size="25" color="#666666"/>
            </div>
            <div style="margin-top: 4px;white-space:nowrap;">上门还车</div>
          </div>
        </div>

        <div style="margin: 7px 12px 7px 12px; background-color: #F5F5F5;border-radius: 10px;padding: 10px;">
          <div style="margin-bottom: 10px;font-weight: bold;color: #303133;font-size: 16px;">业务介绍</div>
          <div v-if="radio === '1'" style="font-size: 15px;color: #515151;font-weight: 500;line-height: 24px;text-indent: 2em;">
            <!--            <div>1、车辆无违章、无交通事故、交强险在有效期内。</div>-->
            <!--            <div>2、车辆无任何改装，车辆外观及灯光完好;车身颜色与驶证照片一致。</div>-->
            <!--            <div>3、轮胎无严重磨损，同轴轮胎花纹必须一致。</div>-->
            <div>预约检车业务是包括车辆检测及专业人员导检的“交钥匙”便捷车检服务。在线下单后，车主只需将车辆自行驾驶至相关检测站办理预约订单核销手续，即可将车辆交由工作人员办理车辆检测相关业务。</div>
            <div>如车辆技能检测合格，工作人员将导车主完成行驶证登记手续;如车辆检测指标出现异常的，车主可自主选择修理渠道，完成维修后交由工作人员完成检测流程。</div>
          </div>

          <div v-else style="font-size: 15px;color: #515151;font-weight: 500;line-height: 24px;text-indent: 2em;">
            <div>代驾检车业务是包括代驾、车辆检测及专业人员导检的一站式车检服务。</div>
            <div>在线下单后，客服人员会联系车主约定上门取还车时间和相关事宜，由专业代驾人员负责提供车辆取还服务。取还车时将根据服务流程对您的爱车车况进行严格检验和记录，确保您的车辆安全。</div>
            <div>如车辆技能检测合格，完成行驶证登记手续后车辆将由代驾人员送回。如车辆检测指标出现异常的，客服人员将联系车主明确修理方式，完成维修后和检测流程由代驾人员送回车辆。</div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {getToken} from '@/utils/auth'

export default {
  name: "index",
  data() {
    return {
      checked: true,
      appointChecked: false,
      radio: '1'
    }
  },
  created() {
    getToken();
  },
  methods: {
    selectRadio(){
      this.radio = '1'
    },
    selectRadio2(){
      this.radio = '2'
    },
    addCar(){
      // window.console.log(this.radio)
      if(this.radio == '1'){
        //预约检车
        this.$router.push({path: '/greenChannel'})
        // this.$router.push({path: '/coupon'})
      }else{
        //上门代检（代驾检车）
        this.$router.push({path: '/appointment'})
      }
    },
    goIntro() {
      this.$router.push({path: '/introduce'})
    }
  },
}
</script>

<style scoped>
.box-top {
  width: 100%;
  height: 200px;
}

.box-inspection {
  height: 140px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.box-handle {
  margin-top: 10px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 17px;
}

.box-handle-select {
  color: #3E82FF;
  border: 1px solid #3E82FF;
  border-radius: 7px;
  background-color: rgba(240, 245, 255, 0.8);
}

.box-process {
  margin-top: 10px;
  margin-bottom: 80px;
  background: #ffffff;
  border-radius: 10px;
  padding-bottom: 12px;
}

.appoint-process {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

</style>
